module.exports = __webpack_public_path__ + "static/ExtendIT-Slider5-45fb58672b9b93065406e3ee934b5b2f.jpg";